export default {
  getRecomendedPosts: state => state.recomendedPosts,
  getSuggestedPosts: state => state.suggestedPosts,
  getRecomendedPost: state => state.recomendedPost,
  getFollowingPosts: state => state.followingPosts,
  //getForYouPosts: (state) => state.forYouPosts,
  getRepliesPosts: state => state.replies,
  getPost: state => state.post,
  getCurrentTime: state => state.now,
  getProfile: state => state.profile,
  getUserReplies: state => state.userReplies,
  getUserReposts: state => state.userReposts,
  getOnlyUserPosts: state => state.onlyUserPosts,
  getReputationCategories: state => state.reputationCategories,
  getLoadStatus: state => state.loadStatus,
  getReportPostId: state => state.reportId,
  getIsReply: state => state.isReply,
  getUsernameData: state => state.usernameData,
  getReplyPostStatus: state => state.replyPostStatus,
  getTotalCountPosts: state => state.totalCountPosts,
  getPositivePosts: state => state.positive,
  getNegativePosts: state => state.negative,
  getAllFollowPosts: state => state.allFollowPosts,
  getRepliesCount: state => blockedUsersIds => {
    return state.replies.filter(reply => {
      return !blockedUsersIds.includes(reply.authorUserId);
    }).length;
  },
  getSearchText: state => state.searchText,
  getSearchUsers: state => state.searchResults.users,
  getSearchPosts: state => state.searchResults.posts,
  getUnreadPosts: state => state.unreadPosts,
  getNoSearchResults: state => state.noSearchResults,
  getIntroPosts: state => state.introPosts,
};
